/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionnaireDevisReponseDto } from './QuestionnaireDevisReponseDto';
import {
    QuestionnaireDevisReponseDtoFromJSON,
    QuestionnaireDevisReponseDtoFromJSONTyped,
    QuestionnaireDevisReponseDtoToJSON,
    QuestionnaireDevisReponseDtoToJSONTyped,
} from './QuestionnaireDevisReponseDto';

/**
 * Answered questions of the risk questionnaire of the quote, with their labels, in display order; empty when the risk carries no questionnaire.
 * 
 * @export
 * @interface GetQuestionnaireDevisResponse
 */
export interface GetQuestionnaireDevisResponse {
    /**
     * Code of the questionnaire, to load its definition; null when there is no answer.
     * @type {string}
     * @memberof GetQuestionnaireDevisResponse
     */
    questionnaireCode?: string | null;
    /**
     * 
     * @type {Array<QuestionnaireDevisReponseDto>}
     * @memberof GetQuestionnaireDevisResponse
     */
    answers: Array<QuestionnaireDevisReponseDto>;
}

/**
 * Check if a given object implements the GetQuestionnaireDevisResponse interface.
 */
export function instanceOfGetQuestionnaireDevisResponse(value: object): value is GetQuestionnaireDevisResponse {
    if (!('answers' in value) || value['answers'] === undefined) return false;
    return true;
}

export function GetQuestionnaireDevisResponseFromJSON(json: any): GetQuestionnaireDevisResponse {
    return GetQuestionnaireDevisResponseFromJSONTyped(json, false);
}

export function GetQuestionnaireDevisResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuestionnaireDevisResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'questionnaireCode': json['questionnaireCode'] == null ? undefined : json['questionnaireCode'],
        'answers': ((json['answers'] as Array<any>).map(QuestionnaireDevisReponseDtoFromJSON)),
    };
}

export function GetQuestionnaireDevisResponseToJSON(json: any): GetQuestionnaireDevisResponse {
    return GetQuestionnaireDevisResponseToJSONTyped(json, false);
}

export function GetQuestionnaireDevisResponseToJSONTyped(value?: GetQuestionnaireDevisResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionnaireCode': value['questionnaireCode'],
        'answers': ((value['answers'] as Array<any>).map(QuestionnaireDevisReponseDtoToJSON)),
    };
}

